import { Application } from "stimulus"
import StripeWalletController from "../controllers/stripe_wallet_controller"

const application = Application.start()
application.register("stripe-wallet", StripeWalletController)
